module.exports = __webpack_public_path__ + "media/images/icons/unfollow-5dd93be9c9d970a45677098b25d590ec.svg";